import { useMutation } from 'react-query'
import { apiClient } from '../../../../api/apiClient'

type TProps = {
  email: string
  file: any
}

const exportResult = async ({ email, file }: TProps): Promise<any> => {
  const formData = new FormData()
  formData.append('email', email)
  formData.append('file', file)

  return await apiClient.post(
    '/email/export-file',
    formData,
    {
      headers: { 'Content-Type': 'multipart/form-data' }
    }
  )
}

export const EXPORT_RESULT_QUERY_KEY = 'exportResult'

export const useExportResultMutation = () =>
  useMutation({
    mutationKey: [EXPORT_RESULT_QUERY_KEY],
    mutationFn: exportResult
  })
